import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  "searchFilter": {
    "ingredients": [], 
    "preparation": undefined, 
    "tags": [], 
    "badges": [], 
    "credits": [], 
    "text": undefined
  } 
};

export const searchFilterSlice = createSlice({
  name: 'searchFilter',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setSearchFilter: (state, action) => {
      if (action.payload) {
        moveWithoutDuplication(state.searchFilter.ingredients, action.payload.ingredients);
        moveWithoutDuplication(state.searchFilter.tags, action.payload.tags);
        moveWithoutDuplication(state.searchFilter.badges, action.payload.badges);
        moveWithoutDuplication(state.searchFilter.credits, action.payload.credits);
      }
    },
    setSearchFilterText: (state, action) => {
      state.searchFilter.text = action.payload;
    },
  },
});

export const { 
  setSearchFilterText,
  setSearchFilter,
} = searchFilterSlice.actions;

export const getSearchFilter = (state) => {
  return state == null ? initialState : state.searchFilter.searchFilter;
};
export const getSearchTextFilter = (state) => {
  return state == null ? null : state.searchFilter.searchFilter.text;
};


export default searchFilterSlice.reducer;

const moveWithoutDuplication = (target, source) => {
  target.splice(0, target.length);
  if (source) {
    for (let i = 0; i < source.length; i++) {
      const element = source[i];
      if (target.indexOf(element) === -1) {
        target.push(element);      
      }
    }
  }
}